import React from "react";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import vi from "date-fns/locale/vi";
import {registerLocale} from "react-datepicker";
import ModalCreateMenuService from "./modalCreateMenuService";
import BusTypeController from "../../../../services/system/bus/bus-type-controller";
import ModalEditMenuService from "./modalEditMenuService";
import GradeManager from "../../../../components/Grade";
registerLocale("vi", vi);
class RegisterEatManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            gradeId: "",
            currentClassRoomId: "",

            assistant1Id: "",
            assistant1Name: "",
            assistant1Username: "",

            driverId: "",
            driverName: "",
            driverUsername: "",

            state: "ACTIVE",
            listData: [],

            pageNumber: 0,
            pageSize: 10,
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Mã thực đơn",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "student",
                    name: "Tên học sinh",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "class",
                    name: "Lớp",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Tiền ăn",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "date",
                    name: "Ngày bắt đầu",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListBusType()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListBusType();
            }
        );
    };
    getListBusType() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            state: this.state.state,
            sort: "created_at desc"
        };
        BusTypeController.list(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    onhandleSearch() {
        this.getListBusType()
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Đang hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Đang khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onUpdateGrade(gradeId){

    }
    renderClassRoom() {

    }
    render() {
        let {listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="register-eat" parentClass="menu-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Đăng ký ăn"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className='col-xs-12 col-sm-12 col-md-6 p-0 pr-3 d-flex mb-2'>
                                                <label className="col-4 label-item pl-0">Khối học</label>
                                                <GradeManager
                                                    isShowText="true"
                                                    gradeId={this.state.gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.currentClassRoomId}
                                                    onChange={(e) => {
                                                        this.state.currentClassRoomId = e.target.value;
                                                        this.setState({
                                                            currentClassRoomId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="0">Chọn lớp</option>
                                                    {this.renderClassRoom()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.currentClassRoomId}
                                                    onChange={(e) => {
                                                        this.state.currentClassRoomId = e.target.value;
                                                        this.setState({
                                                            currentClassRoomId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="0">Chọn trạng thái</option>
                                                    <option value="0">Đăng ký mới</option>
                                                    <option value="0">Hủy đăng ký</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-4">Tên học sinh</label>
                                                <input
                                                    placeholder="Nhập tên học sinh"
                                                    name="title"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.name}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({name: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <button
                                                    style={{height: 35, marginRight: 12}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => {
                                                        this.setState({showModalCreate: true})
                                                    }}
                                                >
                                                    Thêm mới
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                        let a = "";
                                                        let descend = "";
                                                        if (data.sortAsc == null) {
                                                            // a = "id=asc";
                                                            a = "id";
                                                            descend = 'DESC'
                                                        } else {
                                                            a = data.sortId;
                                                            descend = data.sortAsc ? 'ASC' : 'DESC'
                                                        }
                                                        this.setState(
                                                            {
                                                                sort: a,
                                                                descending: descend
                                                            },
                                                            () => this.getListBusType()
                                                        );
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                x1232435
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.name}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                Chú thích thôi
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                Đăng ký mới
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                Đóng theo tháng
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                               23/03/2023
                                                            </td>
                                                            <td style={{textAlign: "center"}}>

                                                                <button className="btn btn-action p-2"
                                                                        title='Sửa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalEdit: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-pencil-alt"/>
                                                                </button>
                                                                <button className="btn btn-action p-2"
                                                                        title='Xóa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalDelete: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-trash"/>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalEditMenuService
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
                <ModalCreateMenuService
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default RegisterEatManagement;
